import { Col, Row, Modal } from "antd";
import Title from "../UI/Title/Title";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useState } from "react";
type propsType = {
  openinfo: boolean;
  setOpenInfo: React.Dispatch<React.SetStateAction<boolean>>;
};
export const ModalInfo = ({ openinfo, setOpenInfo }: propsType) => {
  const [t] = useTranslation("common");

  let time = new Date().toLocaleTimeString();

  let [currentTime, changeTime] = useState(time);

  function checkTime() {
    time = new Date().toLocaleTimeString();

    changeTime(time);
  }

  setInterval(checkTime, 1000);

  return (
    <Modal
      closable={false}
      maskClosable={false}
      width={500}
      onCancel={() => setOpenInfo(false)}
      open={openinfo}
      okButtonProps={{ style: { display: "none" } }}
      cancelButtonProps={{
        style: {
          color: "#1677FF",
          border: "1px solid #1677FF",
          height: "40px",
          width: "100px",
        },
      }}
      cancelText={t("cancel")}
    >
      <Row>
        <Col offset={1} span={23} style={{ marginBottom: "20px" }}>
          <Title title={`${t("session-x")}`} />
        </Col>
        <Col offset={1} span={9}>
          <Col style={{ marginBottom: "5px" }} className="modaltitleEdit">
            {moment().format("DD/MM/YYYY")}
          </Col>
          <Col className="modaltitleEdit">{t("starting-time")}:</Col>
          <Col className="modaltitleEdit">{t("expected-end-time")}:</Col>
          <Col className="modaltitleEdit">{t("current-time")}:</Col>
        </Col>
        <Col span={12}>
          <Col style={{ marginBottom: "5px" }} className="modaltitleEdit">
            {t("workstation")}: Hello World!
          </Col>
          <Col className="modaltitleEdit">
            {localStorage.getItem("startTime")}
          </Col>
          <Col className="modaltitleEdit">00:00</Col>
          <Col className="modaltitleEdit">{currentTime}</Col>
        </Col>
      </Row>
    </Modal>
  );
};
